export default __webpack_public_path__ + "static/media/edu.f70f3ef1.webp";